$(document).ready(() => {
  $('.r7-nav__left__open, .r7-nav__left__menu').click(() => {
    $('.r7-nav__left__menu').toggleClass('r7-nav__left__menu--open');
    $('.r7-nav__left__open').toggleClass('opened');
  });

  $('.r7-nav__right__open, .r7-nav__right__menu').click(() => {
    $('.r7-nav__right__menu').toggleClass('r7-nav__right__menu--open');
    $('.r7-nav__right__open').toggleClass('opened');
  });

  $(window).on('keydown', (e) => {
    if (e.keyCode === 27) {
      $('.r7-nav__right__menu').removeClass('r7-nav__right__menu--open');
      $('.r7-nav__right__open').removeClass('opened');

      $('.r7-nav__left__menu').removeClass('r7-nav__left__menu--open');
      $('.r7-nav__right__open').removeClass('opened');
    }
  });

  const $nav = $('.r7-nav');
  const navPosition = $nav.offset();
  const checkSticky = () => {
    const currentScroll = window.pageYOffset;

    if (navPosition && currentScroll > navPosition.top) {
      $nav.addClass('sticky');
    } else {
      $nav.removeClass('sticky');
    }
  };

  checkSticky();
  $(window).on('scroll', checkSticky);
  $('.r7-nav__right__menu a').on('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    $('.r7-nav__right__menu').removeClass('r7-nav__right__menu--open');
    $('.r7-nav__left__open').removeClass('opened');
    $('.r7-nav__right__open').removeClass('opened');

    const target = $(e.target).attr('href');
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $(target).offset().top,
      },
      1000
    );
  });
});
